import { getConsoleWorkspaceLanding } from '@client/components/_core/navigation/left-nav/workspace-navigation';
import type { FileRouteTypes } from '@client/routeTree.gen';
import { ORG_ROLES, type Role } from '@shared/constants';
import { isFleetPortalOnlyUser } from '@shared/permissions/roles';

/** Redirect Fleet portal users who cannot render Home to an accessible workspace landing. */
export function getHomeRoleRedirectTarget(userRoles: Role[]): FileRouteTypes['to'] | null {
    if (!userRoles.includes(ORG_ROLES.FLEET_PORTAL_USER)) {
        return null;
    }

    const consoleLanding = getConsoleWorkspaceLanding(userRoles);
    if (consoleLanding !== '/console/$orgId') {
        return consoleLanding;
    }

    return isFleetPortalOnlyUser(userRoles) ? '/console/$orgId/fleet-portal' : null;
}
